import { Group, MantineTheme } from "@mantine/core";
import { CircleFilledIcon } from "@mcurros2/microm";
import { IconAlertHexagonFilled, IconCheck, IconSquareXFilled } from "@tabler/icons-react";
import { ReactNode } from "react";


export function StandardViewColumnsOverrides(theme: MantineTheme) {
    return {
        // Personal asignado
        5: { render: (value: unknown) => (!value) ? <Group style={{ gap: '.5rem' }}><IconAlertHexagonFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin personal</Group> : value as ReactNode },
        // Cantidad de clientes
        6: { render: (value: unknown) => (!value || value === '0') ? <Group style={{ gap: '.5rem' }}><IconAlertHexagonFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin clientes</Group> : value as ReactNode },
        // Cantidad de productos
        7: { render: (value: unknown) => (!value || value === '0') ? <Group style={{ gap: '.5rem' }}><IconAlertHexagonFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin productos</Group> : value as ReactNode },
        // Tienda activa
        8: {
            render: (value: unknown) => (value === 'ACTIVO') ?
                <Group style={{ gap: '0rem' }}><CircleFilledIcon mr="xs" width="1.3rem" icon={<IconCheck size="0.9rem" />} />Activa</Group>
                : <Group style={{ gap: '.5rem' }}><IconSquareXFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Baja</Group>
        },
    }
}